<template>
  <div class="row row-space-2">
    <!-- begin widget-chart -->
    <div
      class="widget widget-rounded m-b-30"
      v-bind:class="{ 'inverse-mode': inverseMode }"
    >
      <!-- begin widget-header -->
      <div class="widget-header">
        <h4 class="widget-header-title ts-flex ts-justify-between">
          <div
            class="ts-flexts-justify-content-start"
            :class="{ 'ts-text-gray-700': !inverseMode }"
          >
            <strong>
              {{
                $t('dashboardcomponents.totalStudents&StudentAttendanceStatus')
              }}</strong
            >
          </div>
          <div class="ts-flex ts-justify-content-end ts-justify-item-center">
            <select
              v-model="selectedFilter"
              @change="fetchData"
              class="filter mr-2"
              :class="{ 'filter-dark': inverseMode }"
            >
              <option
                v-for="(filter, filterKey) in filters"
                :value="filterKey"
                :key="filterKey"
              >
                {{ filter }}
              </option>
            </select>
            <a-range-picker
              style="width: 300px"
              v-model="rangeDate"
              :ranges="{
                Today: [moment(), moment()],
                'This Month': [
                  moment().startOf('month'),
                  moment().endOf('month')
                ]
              }"
              format="DD-MM-YYYY"
            />
          </div>
        </h4>
      </div>
      <!-- end widget-header -->
      <!-- begin vertical-box -->
      <ts-loading-banner :loading="loading">
        <div class="vertical-box with-grid with-border-top">
          <!-- begin vertical-box-column -->
          <div
            class="vertical-box-column p-4 widget-chart-content"
            style="width: 30%"
          >
            <p>
              {{
                $t(
                  'dashboardcomponents.pieChartShowsTheStatisticsOfTotalStudentsBasedOnSelectedCategoryAndAPeriodOfDate'
                )
              }}
            </p>
            <pie-chart
              :data="{
                labels: totalStudentLabels,
                datasets: totalStudentDatasets
              }"
              :options="options"
              class="height-sm"
            ></pie-chart>
          </div>
          <!-- end vertical-box-column -->
          <!-- begin vertical-box-column -->
          <div class="vertical-box-column">
            <div class="nv-stacked-area-chart height-full p-4">
              <p>
                {{
                  $t(
                    'dashboardcomponents.barChartsShowTheStatisticsOfStudentsAttendanceIncludingpresenceAbsenceAndLeave'
                  )
                }}
              </p>
              <bar-chart
                :data="{
                  labels: studentAttendanceLabels,
                  datasets: studentAttendanceDatasets
                }"
                :options="{
                  responsive: true,
                  maintainAspectRatio: false
                }"
                class="height-sm"
              ></bar-chart>
            </div>
          </div>
          <!-- end vertical-box-column -->
        </div>
      </ts-loading-banner>
      <!-- end vertical-box -->
    </div>
    <!-- end widget-chart -->
  </div>
</template>
<script>
import BarChart from '@/components/vue-chartjs/BarChart'
import PieChart from '@/components/vue-chartjs/PieChart'
import { map, keys } from 'lodash'
import moment from 'moment'
export default {
  components: {
    BarChart,
    PieChart
  },
  props: ['inverseMode'],
  data() {
    return {
      filters: {
        term_name: 'Term',
        acps_abbr: 'Sub Progam',
        acp_abbr: 'Academic Progam'
      },
      loading: false,
      selectedFilter: '',
      rangeDate: [moment().add(-3, 'Month'), moment()],
      totalStudent: [],
      studentAttendance: [],
      status: ['Presence', 'Absence', 'Leave'],
      borderColor: ['#28a745', '#D35400', '#7F8C8D'],
      backgroundColor: [
        'rgba(40, 167, 69, 0.5)',
        'rgba(211, 84, 0, 0.5)',
        'rgba(127, 140, 141 , 0.5)'
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      }
    }
  },
  computed: {
    studentAttendanceLabels() {
      return keys(this.studentAttendance)
    },
    studentAttendanceDatasets() {
      return this.status.map((s, index) => {
        return {
          label: s,
          borderColor: this.borderColor[index],
          backgroundColor: this.backgroundColor[index],
          borderWidth: 1,
          data: map(this.studentAttendance, r => {
            return r[s]
          })
        }
      })
    },
    totalStudentLabels() {
      return keys(this.totalStudent)
    },
    totalStudentDatasets() {
      return [
        {
          data: map(this.totalStudent, r => {
            return r
          }),
          backgroundColor: map(this.totalStudent, r => {
            return this.random_rgba()
          }),
          borderColor: map(this.totalStudent, r => {
            return '#F2F3F4'
          }),
          borderWidth: 1
        }
      ]
    }
  },
  mounted() {
    this.selectedFilter = Object.keys(this.filters)[0]

    this.fetchTotalStudent()
    this.fetchStudentAttendance()
  },
  methods: {
    moment,
    random_rgba() {
      var o = Math.round,
        r = Math.random,
        s = 255
      return (
        'rgba(' +
        o(r() * s) +
        ',' +
        o(r() * s) +
        ',' +
        o(r() * s) +
        ',' +
        0.6 +
        ')'
      )
    },
    fetchData() {
      this.fetchTotalStudent()
      this.fetchStudentAttendance()
    },
    fetchTotalStudent() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchTotalStudent', {
          group_by: this.selectedFilter
        })
        .then(responses => {
          this.totalStudent = responses
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    fetchStudentAttendance() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchStudentAttendance', {
          group_by: this.selectedFilter,
          date_from: this.rangeDate[0].format('DD-MM-YYYY'),
          date_to: this.rangeDate[1].format('DD-MM-YYYY')
        })
        .then(responses => {
          this.studentAttendance = responses
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  },
  watch: {
    rangeDate: function() {
      this.fetchData()
    }
  }
}
</script>
<style scoped>
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.widget-header-title,
.widget-header-icon {
  padding: 5px 10px !important;
}
</style>
